import styled from "styled-components";

export type TextType = {
    color: string;
    size: number;
}

export type ContainerType = {
    background: string;
}

export const ContentInfos = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
`;
export const ContentButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Text = styled.span<TextType>`
    font-size: ${(props) => props.size}px;
    color: ${(props) => props.color};
`;

export const TextBold = styled.span<TextType>`
    font-size: ${(props) => props.size}px;
    color: ${(props) => props.color};
    font-weight: bold;
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px 0 0;
`;

export const IconBadge = styled.div<ContainerType>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: ${props => props.background};
`;

export const DescriptionWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;
